export default "__VITE_ASSET__8bdf85e3__"